import { lazy, useState, useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';

import getLyocCookie from '@/Cookies';
import Board3D from '@/page/Board3D';
import Board3DTutorial from '@/page/Board3DTutorial';
import Credit from '@/page/Credit';
import GameHub from '@/page/GameHub';
import Login from '@/page/Login';
import Register from '@/page/Register';
import { useGameState } from '@/state/gameButler/useGameState';
import { useViewState } from '@/state/viewButler/useViewState';

import NavCluster from './components/game/ui/corner/NavCluster';
import './App.css';
import LyocTitle from './components/static/LyocTitle';
import { GameContext, ViewContext } from './state/contexts';

const Game = lazy(() => import('./page/Game'));

function App() {
	const [token, setToken] = useState(getLyocCookie()); // const cookieName = 'lyoc_cookie';

	const gameContextObj = useGameState();
	const viewContextObj = useViewState();

	if (!token) {
		return (
			<div className="App">
				<div className="mainBody">
					<br />
					<br />
					<br />
					<HashRouter>
						<GameContext.Provider value={gameContextObj}>
							<ViewContext.Provider value={viewContextObj}>
								<Routes>
									<Route
										path="/"
										element={<Login setToken={setToken} />}
									/>
									<Route
										path="register/*"
										element={<Register />}
									/>
									<Route
										path="credit/*"
										element={<Credit />}
									/>
									<Route
										path="game-hub/*"
										element={
											<GameHub multiplayer={false} />
										}
									/>
									<Route
										path="board3d/*"
										element={<Board3D />}
									/>
									<Route
										path="board3dtutorial/*"
										element={<Board3DTutorial />}
									/>
								</Routes>
								<NavCluster />
							</ViewContext.Provider>
						</GameContext.Provider>
					</HashRouter>
				</div>
			</div>
		);
	}

	return (
		<>
			<Game />
		</>
	);
}

export default App;
